app.controller('AccountCommonAddressSavedController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    $scope.view_model = {
        confirm_delete_address_id: null
    };

    $scope.deleteAddress = function (setAlerts, address) {

        setAlerts([]);
        $scope.form_disabled = true;
        $rootScope.service.account.deleteAddress(address._id, function (success, data, messages) {
            $scope.form_disabled = false;
            $scope.view_model.confirm_delete_address_id = null;
            setAlerts(messages);
        });

    };
}]);